import { readMultiNum, readSingleNum } from "../../../utils";
export function readFeatureTableObject(v) {
    // Some shitty data will just not have a feature table for w/e reason. This is how we work around it.
    if (v.text.length === 0) {
        return {
            batchLength: 0,
        };
    }
    // Parse the feature table JSON and assert we got an object
    const featureTableObject = JSON.parse(v.text);
    const acc = {};
    // Read BATCH_LENGTH
    const batchLength = readSingleNum(v.data, 2 /* NumType.U32 */, featureTableObject.BATCH_LENGTH);
    if (typeof batchLength !== "undefined") {
        acc.batchLength = batchLength;
    }
    // Read RTC_CENTER
    const rtcCenter = readMultiNum(v.data, 3, 8 /* NumType.F32 */, featureTableObject.RTC_CENTER);
    if (typeof rtcCenter !== "undefined") {
        acc.rtcCenter = [rtcCenter[0], rtcCenter[1], rtcCenter[2]];
    }
    return {
        batchLength: acc.batchLength,
        rtcCenter: acc.rtcCenter,
    };
}
// export function readBatchTableObject(_v: { text: string; data: DataView } | undefined): {} | undefined {
//     throw new Error("Unimplemented");
// }
